import {Component} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '@shared/services/security/auth.service';
import {SpinnerComponent} from '@shared/components/spinner/spinner.component';
import {DeviceInfoService} from "@shared/services/device-info/device-info.service";

@Component({
    selector: 'app-signin',
    imports: [CommonModule, RouterLink, ReactiveFormsModule, SpinnerComponent],
    providers: [],
    templateUrl: './signin.component.html',
    styleUrl: './signin.component.scss'
})
export class SigninComponent {
    signinForm!: FormGroup;
    errorMessage!: string;
    loading = false;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private router: Router,
        public toastr: ToastrService,
        private deviceInfoService: DeviceInfoService
    ) {
    }

    ngOnInit(): void {
        if (this.authService.isUserLogged) {
            this.router.navigate(['']);
        }
        this.signinForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required]]
        });
    }

    onSubmit() {
        if (this.signinForm.valid) {
            this.loading = true
            const {email, password} = this.signinForm.value;
            const deviceInfo = this.deviceInfoService.getDeviceInfo();
            this.authService.signIn(email, password, deviceInfo).subscribe({
                next: (res: boolean) => {
                    if (res) {
                        this.router.navigate(['']);
                        this.toastr.success('Sign In Step-one Successful', ' ');
                    }
                    this.loading = false
                },
                error: (error) => {
                    this.loading = false
                    this.errorMessage = error.error.error;
                    this.toastr.error(this.errorMessage); // Assuming API returns error message
                    console.error('Sign in error:', error);
                }
            });
        } else {
            // Mark fields as touched to trigger validation messages
            this.signinForm.markAllAsTouched();
        }
    }
}
